document.addEventListener('DOMContentLoaded', function () {
  var debounceTimer;

  function syncHeight() {
    document.querySelectorAll('[data-htu-wrap]').forEach(function (wrap) {
      var body = wrap.closest('.htu__body');
      if (!body) return;
      var stepsCol = body.querySelector('.htu__steps-col');
      if (!stepsCol) return;
      if (window.innerWidth >= 768) {
        stepsCol.style.minHeight = wrap.offsetHeight + 'px';
        stepsCol.style.height = '';
      } else {
        stepsCol.style.height = '';
        stepsCol.style.minHeight = '';
      }
    });
  }

  syncHeight();

  window.addEventListener('resize', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncHeight, 150);
  });

  // Posters are data-poster so they don't compete with the page's main image on
  // load; set them once the section is within ~600px of the screen.
  var setPoster = function (video) {
    if (video.dataset.poster && !video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
  };
  var posterVideos = document.querySelectorAll('.htu__video[data-poster]');
  if ('IntersectionObserver' in window) {
    var posterIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        setPoster(entry.target);
        posterIo.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    posterVideos.forEach(function (video) { posterIo.observe(video); });
  } else {
    posterVideos.forEach(setPoster);
  }

  document.querySelectorAll('[data-htu-wrap]').forEach(function (wrap) {
    var video = wrap.querySelector('.htu__video');
    if (!video) return;

    var muteBtn = wrap.querySelector('.htu__mute-btn');

    wrap.addEventListener('click', function () {
      setPoster(video);
      if (video.paused) {
        video.play();
        wrap.classList.add('htu__video-wrap--playing');
      } else {
        video.pause();
        wrap.classList.remove('htu__video-wrap--playing');
      }
    });

    video.addEventListener('ended', function () {
      wrap.classList.remove('htu__video-wrap--playing');
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        wrap.classList.toggle('htu__video-wrap--muted', video.muted);
      });
    }
  });
});
